export default {
  INDOOR: 'INDOOR',
  OUTDOOR: 'OUTDOOR',
};
